import api from "./api";

export const getClause = async () => {

    const response = await api.get(`/api/clauses`);
    return response.data;
}